const radialChart = {
  chart: {
    height: 250,
    type: "radialBar",
    toolbar: {
      show: false,
    },
    colors: ["#AAF40C", "#097E52"],
    plotOptions: {
        radialBar: {
          dataLabels: {
            name: {
              fontSize: "14px",
            },
            value: {
              fontSize: "20px",
            },
            total: {
              show: true,
              label: "Total Earnings",
              formatter: function (w) {
                return 4050;
              },
            },
          },
        },
      },
  },
  series: [44, 55],
  labels: ["Cages", "Coaching"],
};

export { radialChart };
